export const gx = {
  red: "#D71920",
  orange: "#F7931E",
  navy: "#022A3A",
  teal: "#033b51",
  canvas: "#F4F6F8",
  surface: "#FBFCFD",
  ink: "#1C2429",
  inkSoft: "#5B676F",
  border: "#E2E8ED",
  excel: "#107c41",
  radius: {
    control: 10,
    surface: 12,
    pill: 999,
  },
  z: {
    sticky: 30,
    nav: 40,
    overlay: 50,
    popup: 55,
  },
  motion: {
    duration: "200ms",
    ease: "cubic-bezier(0.16, 1, 0.3, 1)",
  },
};

export const fontFamily =
  '"Outfit", "Segoe UI", system-ui, sans-serif';
